import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { requestBuilder } from '../../http/RequestBuilder';
import { quilttSessionTokenAtom } from '../state/HolisticAtoms';

interface UseGetQuilttSessionResponse {
    token: string;
}

const useFetchQuilttSession = requestBuilder.query<UseGetQuilttSessionResponse>(
    {
        endpoint: '/api/linked-accounts/quiltt/session',
        queryKey: 'quilttSession',
    },
);

const useGetQuilttSession = () => {
    const [quilttSessionToken, setQuilttSessionToken] = useAtom(
        quilttSessionTokenAtom,
    );
    const { data, isLoading, error } = useFetchQuilttSession({});

    useEffect(() => {
        if (data) {
            setQuilttSessionToken(data.token);
        }
    }, [data]);

    return {
        data: quilttSessionToken,
        isLoading,
        error,
    };
};

export default useGetQuilttSession;
